import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule, PageMetaModule } from '@spartacus/core';
import { CustomCategorySummaryComponent } from './custom-category-summary.component';

@NgModule({
  declarations: [CustomCategorySummaryComponent],
  imports: [
    CommonModule,
    PageMetaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CustomCategorySummaryComponent: {
          component: CustomCategorySummaryComponent,
        }
      }
    } as CmsConfig),
    I18nModule
  ],
  exports: [
    CustomCategorySummaryComponent
  ]
})
export class CustomCategorySummaryModule { }
